import React, { useContext, useMemo } from 'react'

import SelectAllCell from './SelectAllCell'
import PeriodsValidationCell from './PeriodsValidationCell'
import AssetCol from '../../../../../../ProductsTable/cols/AssetCol'
import ReachCol from '../../../../../../ProductsTable/cols/ReachCol'
import RegionCol from '../../../../../../ProductsTable/cols/RegionCol'
import LocationCol from '../../../../../../ProductsTable/cols/LocationCol'
import CategoryCol from '../../../../../../ProductsTable/cols/CategoryCol'
import RateCell from '../../../../../../ProductsTable/cols/RateCol/RateCell'
import AssetTypeCol from '../../../../../../ProductsTable/cols/AssetTypeCol'
import ThumbnailCell from '../../../../../../../../../../../components/Table/ReusableCells/Thumbnail'
import RowSelectionCell from '../../../../../../../../../../../components/Table/ReusableCells/RowSelectionCell'

import { AddProductsBulkContext } from '../../../../AddProductsBulkContext'

import { insertIf } from '../../../../../../../../../../../helpers/common'

import { tableColumnsSize } from '../const/columns'
import { rateColStyles } from '../../../../../../ProductsTable/const/tableColumnsSize'

const usePreviewProductColumns = ({
  classes,
  hasReachData,
  currencySymbol,
  validProductsIds,
  openProductImagesModal
}) => {
  const { hideUnavailable } = useContext(AddProductsBulkContext)

  return useMemo(() => {
    return [
      {
        header: () => <SelectAllCell validProductsIds={validProductsIds} />,
        headClassName: classes.quotationBuilderCol,
        className: classes.quotationBuilderCol,
        Cell: productValues => {
          const isValid = validProductsIds.includes(productValues.id)
          return isValid && <RowSelectionCell rowId={productValues.id} Context={AddProductsBulkContext} />
        },
        style: { minWidth: tableColumnsSize.checkbox, maxWidth: tableColumnsSize.checkbox }
      },
      {
        Cell: ({ data }) =>
          data?.images?.[0] && (
            <ThumbnailCell
              onClick={() => openProductImagesModal(data.id, data?.images?.[0].id)}
              imageUrl={data?.images[0].thumbnail}
            />
          ),
        style: { minWidth: tableColumnsSize.thumbnail, maxWidth: tableColumnsSize.thumbnail }
      },
      RegionCol({ classes, hasReachData }),
      LocationCol({ classes }),
      CategoryCol({ classes, hasReachData }),
      AssetTypeCol({ classes }),
      AssetCol({ classes }),
      ...insertIf(!hideUnavailable, {
        headClassName: classes.quotationBuilderCol,
        className: classes.quotationBuilderCol,
        Cell: productValues => (
          <PeriodsValidationCell productValues={productValues} isValid={validProductsIds.includes(productValues.id)} />
        ),
        style: { minWidth: tableColumnsSize.periodsValidation, maxWidth: tableColumnsSize.periodsValidation }
      }),
      ...insertIf(hasReachData, ReachCol({ classes })),
      {
        header: 'Rate',
        headClassName: classes.quotationBuilderCol,
        className: classes.quotationBuilderCol,
        style: { ...rateColStyles, paddingRight: 20 },
        Cell: productValues => {
          // hide products without available periods rate
          const isValid = validProductsIds.includes(productValues.id)
          return isValid && <RateCell productValues={productValues} currencySymbol={currencySymbol} />
        }
      }
    ]
  }, [classes, hasReachData, hideUnavailable, currencySymbol, validProductsIds, openProductImagesModal])
}

export default usePreviewProductColumns
